"use client";

import { usePathname } from "next/navigation";
import { Suspense } from "react";

import { Footer } from "@/components/layout/footer";
import { Navbar } from "@/components/layout/navbar";
import { MobileBottomNav } from "@/components/layout/mobile-bottom-nav";
import { AiShoppingAssistant } from "@/components/ai/shopping-assistant";

export function StoreShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isPortal = Boolean(pathname?.startsWith("/admin") || pathname?.startsWith("/vendor"));

  // Admin and Vendor dashboard portals do not show consumer shopping chrome
  if (isPortal) {
    return <>{children}</>;
  }

  return (
    <>
      <Suspense fallback={null}>
        <Navbar />
      </Suspense>
      <main className="flex-1 bg-amazon-page dark:bg-slate-950 pb-16 sm:pb-0">{children}</main>
      <Footer />
      <MobileBottomNav />
      <AiShoppingAssistant />
    </>
  );
}
